export const asComplete = {
  data: `<svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.1875 8C2.75 8 1.4375 7.25 0.71875 6C0 4.76562 0 3.25 0.71875 2C1.4375 0.765625 2.75 0 4.1875 0C5.60938 0 6.92188 0.765625 7.64062 2C8.35938 3.25 8.35938 4.76562 7.64062 6C6.92188 7.25 5.60938 8 4.1875 8ZM5.95312 3.26562H5.9375C6.09375 3.125 6.09375 2.89062 5.9375 2.73438C5.79688 2.59375 5.5625 2.59375 5.42188 2.73438L3.6875 4.48438L2.95312 3.75C2.79688 3.59375 2.5625 3.59375 2.42188 3.75C2.26562 3.89062 2.26562 4.125 2.42188 4.26562L3.42188 5.26562C3.5625 5.42188 3.79688 5.42188 3.95312 5.26562L5.95312 3.26562Z" fill="currentColor"/>
</svg>
`,
  name: 'complete',
};
